// -------------------------- library
import * as yup from "yup";
import { useCallback, useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Modal, Tab, Tabs } from "react-bootstrap";
import { IoClose } from "react-icons/io5";
import { isEmpty } from "lodash";
import toast from "react-hot-toast";

// -------------------------- local function
import FirstDetails, { translateCategory } from "./FirstDetails";
import useAxios from "services/useAxios.tsx";

import { checkImageType } from "../../../../utils/Helper.ts";
import WebInfoContext from "context/WebInfo/WebInfoContext.ts";
import { pathMaker } from "utils/helperFunctions.js";
import useWindowSize from "hoc/useWindowSize";
import TranslateApi from "../../../../utils/TranslateApi.ts";
import CustomButton from "components/kits/custom-button/CustomButton.tsx";

// -------------------------- local file
import "./insert-product.scss";
import ColorSchema from "assets/kits/color/index.ts";
import OptionsProduct, { arrayToSelectOptions } from "./OptionsProduct";
import InventoryProduct from "./InventoryProduct";
import FinalDetails from "./FinalDetails";
import ProductContext from "context/ProductContext/ProductDataContext";

// -------------------------- static variable

const msg = {
  successEdit: "با موفقیت ویرایش شد.",
  successAddProduct: "با موفقیت اضافه گردید شد.",
  errorConnection: "ارتباط ناموفق، لطفا اینترنت خود را چک کنید!",
  errorBadResponse: "خطا در ارتباط! به پشتیبانی اطلاع دهید.",
};

const emptyForm = {
  title: "",
  description: "",
  coverImage: "",
  category: "",
  subCategorys: "",
  optionsProduct: [],
  finalDescription: "",
};

// -------------------------- end static variable

/*
    const [controllerProduct, setControllerProduct] = useState({show: false, type: "add", details: {}});
 */

const InsertProductModal = ({
  controller: { type, show, details },
  setController,
  reload,
}) => {
  const { categorys } = useContext(WebInfoContext);
  const { setProductListUpdater } = useContext(ProductContext);
  const { execute: addProductApi } = useAxios("api3/add_product");
  const { execute: updateProductApi } = useAxios("api3/edit_product");

  const [defaultValue, setDefaultValue] = useState(emptyForm);
  const [loading, setLoading] = useState(false);
  const [optionsProduct, setOptionsProduct] = useState([]);
  const [indentorys, setInventorys] = useState([]);
  const [files, setFiles] = useState({ cover: {}, file: [] });

  const { width } = useWindowSize();

  const schema = yup
    .object({
      title: yup.string().required("عنوان نباید خالی باشد."),
      description: yup.string().notRequired(),
      finalDescription: yup.string().notRequired(),
      category: yup
        .mixed()
        .test("category", "دسته بندی باید انتخاب شود", (value) => {
          if (!value) return false;
          if (value == "") return false;
          if (value.length < 1) return false;
          return true;
        }),
      subCategorys: yup
        .mixed()
        .test("subCategorys", "زیر دسته باید انتخاب شود", (value) => {
          if (!value) return false;
          if (value == "") return false;
          if (value.length < 1) return false;
          return true;
        }),
    })
    .required();

  // چک کردن نبودن ویژگی تکراری
  const verifyOptionList = (
    options,
    oldOption = undefined,
    isChangedPrice = false,
    selectedFeaturs = []
  ) => {
    if (options.length == 0) return options;
    let tempOptions = [];

    options.map((option) => {
      if (!tempOptions.some((item) => item.option_id == option.option_id)) {
        if (
          (oldOption &&
            !oldOption.some((item) => item.option_id == option.option_id)) ||
          !oldOption
        ) {
          tempOptions.push({
            ...option,
            isChangedPrice: isChangedPrice,
            selectedFeaturs: selectedFeaturs,
          });
        }
      }
    });
    return tempOptions;
  };

  // submit
  const onSubmit = (data) => {
    console.log(data);

    if (loading) return toast.error("در حال پردازش...");

    if (indentorys.length == 0)
      return toast.error("محصول باید حداقل یک موجودی داشته باشد.");

    if (indentorys.length == 0)
      return toast.error("محصول باید حداقل یک موجودی داشته باشد.");

    setLoading(true);
    let formData = new FormData();
    let tempHasFile = [];

    // Options
    let tempOptions = [];
    optionsProduct.map((option) => {
      let featurs = option.selectedFeaturs;
      if (featurs.length == 0) return;
      featurs.map((it) => {
        tempOptions = [...tempOptions, `${it.id},${+option.isChangedPrice}`];
      });
    });

    // Inventory
    let tempInventory = [];
    indentorys.map((inventory) => {
      let tempFeature = inventory.optionValue.map((it) => ({
        option_feature_id: it.id,
        option_id: it.option_id,
      }));

      tempInventory.push({
        inventory: inventory.inventory,
        price: inventory.price,
        discount: inventory.discount,
        discount_endtime: inventory.discountTime,
        feature_json: tempFeature,
        filename:
          tempFeature.length == 0 || inventory == {} || isEmpty(inventory.file) || inventory.file.id
            ? "none"
            : `file_inventory_${inventory.index}`,
      });
      // file inventory
      if (tempFeature.length != 0 && inventory != {} && !isEmpty(inventory.file) && !inventory.file.id) {
        formData.append(
          `file_inventory_${inventory.index}`,
          inventory.file.file
        );
      } else if (inventory?.file?.id) {
        tempHasFile.push(inventory?.file?.id);
      }
    });

    if (files.cover) {
      !files.cover.id
        ? formData.append("cover_img", files.cover.file)
        : tempHasFile.push(files.cover.id);
    } else {
      toast.error("کاور محصول اجباری می باشد.");
      return;
    }

    if (files.file && files.file.some((it) => !it.id)) {
      formData.append("file_count", files.file.filter((it) => !it.id).length);
      files.file
        .filter((it) => !it.id)
        .map((file, index) => {
          formData.append(`file_${index}`, file.file);
        });
    }

    formData.append("title", data.title);
    formData.append("description", data.description);
    formData.append("details", data.finalDescription);
    formData.append("product_option_features", tempOptions.join("@@"));
    formData.append("product_prices", JSON.stringify(tempInventory));
    formData.append(
      "hashtags",
      data.subCategorys.map((it) => it.value).join(",")
    );

    // setLoading(false);

    // inventory files
    tempHasFile.push(...files.file.map((it) => it.id));
    // console.log(tempHasFile);
    if (type == "add") {
      addProductApi(formData)
        .then(({ result }) => {
          if (result == 1) {
            toast.success(msg.successAddProduct);
            allReset();
            setController((s) => ({ ...s, show: false }));
          } else {
            toast.error(msg.errorConnection);
          }
          console.log(loading);

          setLoading(false);
          setProductListUpdater((prev) => !prev);
        })
        .catch((err) => {
          toast.error(msg.errorConnection);
          console.log(loading);

          setLoading(false);
        });
    } else if (type == "edit") {
      formData.append("product_id", data.id);
      formData.append("has_file", tempHasFile.join(","));

      updateProductApi(formData)
        .then(({ status }) => {
          if (status == 1) {
            toast.success(msg.successEdit);
            allReset();
            setController((s) => ({ ...s, show: false }));
          } else {
            toast.error(msg.errorConnection);
          }
          setLoading(false);
          setProductListUpdater((prev) => !prev);
        })
        .catch((err) => {
          toast.error(msg.errorConnection);
          setLoading(false);
        });
    }
  };

  // reset form and details
  const allReset = () => {
    formController.reset();
    formController.resetField("category");
    setOptionsProduct([]);
    setInventorys([]);
    setFiles({ cover: {}, file: [] });
  };

  // translate details api to form details
  const translateDetails = useCallback(
    (data) => {
      if (!show || type == "add") {
        setDefaultValue(emptyForm);
        return;
      }

      console.log("translate: ", data);

      let tempSubsSelected = [],
        tempOptions = [];
      let tempCategory = {};
      let tempFile = data.files.map((it, index) => ({
        index,
        id: it.file_id,
        preview: pathMaker(it.url),
        type: checkImageType(it.url, true),
      }));

      let productPrices = data.product_prices;
      let features = [];
      let tempInventory = [];

      // optios, selectedOptions, checkedOption
      if (
        data.hashtags.length > 0 &&
        data.hashtags.filter((it) => it.hashtag_status == "0").length > 0
      ) {
        let categorySelected = data.hashtags.filter(
          (it) => it.hashtag_status == "0"
        )[0];
        tempCategory = translateCategory(
          categorys.filter(
            (item) => item.hashtag.id == categorySelected.hashtags_id
          )[0]
        );

        tempOptions = verifyOptionList(tempCategory.optionList);

        if (tempCategory) {
          let tempSubs = data.hashtags.filter((it) => it.hashtag_status != "0");
          if (tempSubs.length) {
            tempSubs.map((it) => {
              if (tempCategory.subs?.length) {
                let opt = tempCategory.subs.filter(
                  (sub) => sub.value == it.hashtags_id
                )[0];
                tempOptions.push(
                  ...verifyOptionList(opt.optionList, tempOptions)
                );
                // productPrices[0].feature_json.length > 0 ? JSON.parse(productPrices[0].feature_json) :
                // productPrices.map(productPrice => {
                //     if (productPrice.feature_json.length > 0) {
                //         features = [...features, ...JSON.parse(productPrice.feature_json)];
                //     }
                // })
                // console.log("lent: ",features);
                features = productPrices.flatMap((productPrice) =>
                  !!productPrice.feature_json.length
                    ? JSON.parse(productPrice.feature_json).map((fe) => {
                        return {
                          ...fe,
                          inventoryId: productPrice.id,
                        };
                      })
                    : []
                );
                tempSubsSelected.push(opt);
              }
            });

            data.options.map((it) => {
              tempOptions = tempOptions.map((item) => {
                if (item.option_id == it.option_id) {
                  return {
                    ...item,
                    selectedFeaturs: [
                      ...item.selectedFeaturs,
                      ...arrayToSelectOptions(
                        item.features.filter(
                          (fe) => fe.id == it.option_feature_id
                        )
                      ),
                    ],
                    isChangedPrice:
                      features.filter((fe) => fe.option_id == item.option_id)
                        .length > 0,
                  };
                } else {
                  return item;
                }
              });
            });
          }
        }
      }

      // inventory
      productPrices.map((productPrice, index) => {
        tempInventory.push({
          index,
          price: productPrice.price,
          file: {
            id: productPrice.files_id,
            preview: pathMaker(productPrice.url),
            type: "image",
          },
          inventory: productPrice.inventory,
          discount: +productPrice.discount ? productPrice.discount : "",
          discountTime: TranslateApi.dateToRHF(productPrice.discount_endtime),
          optionValue: features
            .map((fe) => {
              let temp = tempOptions.filter(
                (it) =>
                  it.isChangedPrice == true && it.option_id == fe.option_id
              )[0];
              if (productPrice.id == fe.inventoryId && temp)
                return {
                  ...temp?.selectedFeaturs.filter(
                    (se) => se.id == fe.option_feature_id
                  )[0],
                  title: temp.title,
                };
            })
            .filter((fe) => fe),
        });
      });

      console.log("tempInventory: ", tempInventory);

      setFiles({
        cover: {
          id: data.coverimg_fileid,
          preview: pathMaker(data.file),
          type: "image",
        },
        file: tempFile,
      });

      setOptionsProduct(tempOptions);
      setInventorys(tempInventory);
      console.log({ data });
      setDefaultValue({
        id: data.id,
        title: data.title,
        description: data.description,
        category: tempCategory,
        subCategorys: tempSubsSelected,
        finalDescription: data.details,
      });
    },
    [details]
  );

  const formController = useForm({
    resolver: yupResolver(schema),
    values: defaultValue,
    defaultValues: defaultValue,
    resetOptions: {
      keepErrors: true,
    },
  });

  // watcher form
  useEffect(() => {
    const subscription = formController.watch((value, { name, type }) => {
      if (name == "category" && !isEmpty(value.category)) {
        setOptionsProduct(verifyOptionList(value.category.optionList));
        formController.setValue("subCategorys", []);
      }

      if (
        name == "subCategorys" &&
        !isEmpty(value.subCategorys) &&
        value.subCategorys.length > 0
      ) {
        let tempOpt = [...optionsProduct];
        value.subCategorys.map((it) => {
          console.log(...verifyOptionList(it.optionList, tempOpt));
          tempOpt.push(...verifyOptionList(it.optionList, tempOpt));
        });
        console.log("sub: ", tempOpt);
        setOptionsProduct(tempOpt);
      }
    });
    return () => subscription.unsubscribe();
  }, [formController.watch, optionsProduct]);

  // onChange Show State
  useEffect(() => {
    if (!show) return allReset();

    translateDetails(details);
  }, [show]);
  return (
    <Modal
      className="insert-product pd-r-0 d-flex justify-content-center overflow-hidden"
      show={show}
      fullscreen={"xl-down"}
      backdropClassName="show"
      size="xl"
      dialogClassName="w-100 "
      onBackdropClick={() =>
        setController((s) => ({ ...s, show: false, details: {} }))
      }
    >
      <Modal.Header>
        <span className="font-18-600">
          {type == "add" ? "افزودن" : "ویرایش"} محصول
        </span>
        <div
          className="cursor-pointer"
          onClick={() =>
            setController((s) => ({ ...s, show: false, details: {} }))
          }
        >
          <IoClose
            className="wh-24 text-secondary pointer"
            color={ColorSchema.blue_13}
          />
        </div>
      </Modal.Header>
      <Modal.Body
        style={{
          maxHeight: width > 1200 && "calc(100vh - 180px)",
          minHeight: width > 1200 && "calc(100vh - 180px)",
          overflowY: "auto",
        }}
        className="w-100 pd-t-16 pd-x-8 font-14-600 color-bk-04"
      >
        <form
          id="insert-product-form"
          onSubmit={formController.handleSubmit(onSubmit)}
        >
          <Tabs id="insert-product-tab">
            <Tab eventKey="first-data" title="اطلاعات اولیه">
              <FirstDetails
                files={files}
                setFiles={setFiles}
                formControl={formController}
              />
            </Tab>

            <Tab eventKey="options" title="ویژگی ها">
              <OptionsProduct
                formControl={formController}
                options={optionsProduct}
                setOptions={setOptionsProduct}
              />
            </Tab>

            <Tab eventKey="inventory" title="موجودی">
              <InventoryProduct
                formControl={formController}
                invenrotys={indentorys}
                importData={true}
                setInventorys={setInventorys}
                options={optionsProduct}
              />
            </Tab>

            <Tab eventKey="final-details" title="اطلاعات تکمیلی">
              <FinalDetails formControl={formController} />
            </Tab>
          </Tabs>
        </form>
      </Modal.Body>

      <Modal.Footer style={{ padding: "8px 16px" }}>
        <div style={{ margin: 0 }}>
          <CustomButton
            state={loading ? "loading" : "default"}
            type="submit"
            onClick={() => {
              let error = [];
              console.log(formController.formState.errors);
              for (let [err, index] of Object.entries(
                formController.formState.errors
              )) {
                console.log(err);
                error.push(index.message);
              }
              if (error.length > 0) toast.error(error[0]);
            }}
            form="insert-product-form"
            className="bg-success wd-80 "
            color={ColorSchema.blue_11}
            textColor={ColorSchema.white}
          >
            <span className="font-14-600 text-white">
              {type == "add" ? "ثبت" : "ویرایش"}
            </span>
          </CustomButton>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default InsertProductModal;
